export const actionTypes = {
  FAILED: 'setting-sub-merchant/failed',
  LOADING: 'setting-sub-merchant/loading',
  SUCCESS: 'setting-sub-merchant/success',
  MESSAGE: 'setting-sub-merchant/message',
  RESET: 'setting-sub-merchant/reset',
};

export const mappingDataIdentity = (data) => {
  return [
    {
      label: 'Nama',
      needLoadingState: true,
      value: `${data?.name || '-'}`
    },
    {
      label: 'NIK KTP',
      needLoadingState: true,
      value: `${data?.nationalityId || '-'}`
    },
    {
      label: 'Nomor Ponsel',
      needLoadingState: true,
      value: `${data?.phoneNumber || '-'}`
    },
    {
      label: 'Alamat Sesuai KTP',
      needLoadingState: true,
      value: `${data?.street || '-'}`
    },
    {
      label: 'Provinsi',
      value: `${data?.province || '-'}`
    },
    {
      label: 'Kota/Kabupaten',
      value: `${data?.city || '-'}`
    },
    {
      label: 'Kecamatan',
      value: `${data?.district || '-'}`
    },
    {
      label: 'Kelurahan',
      value: `${data?.village || '-'}`
    },
  ];
};

export const mappingDataUser = (data) => {
  return [
    {
      label: 'Nama Usaha',
      needLoadingState: true,
      value: `${data?.storeName || '-'}`
    },
    {
      label: 'NIB',
      needLoadingState: true,
      value: `${data?.nib || '-'}`
    },
    {
      label: 'Alamat Usaha',
      needLoadingState: true,
      value: `${data?.businessStreet || '-'}`
    },
    {
      label: 'Provinsi',
      value: `${data?.province || '-'}`
    },
    {
      label: 'Kota/Kabupaten',
      value: `${data?.city || '-'}`
    },
    {
      label: 'Kecamatan',
      value: `${data?.district || '-'}`
    },
    {
      label: 'Kelurahan',
      value: `${data?.village || '-'}`
    },
  ];
};

export const mappingDataMerchant = (data) => {
  return [
    {
      label: 'ID Pangkalan',
      value: `${data?.registrationId || '-'}`
    },
    {
      label: 'Nama Pangkalan',
      value: `${data?.storeName || '-'}`
    },
    {
      label: 'Tanggal Pendaftaran',
      value: `${data?.registrationDate || '-'}`
    },
  ];
};
